import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const QnA006 = ({ isOpened, onChangeOpenedFlag }) => {
    const { t } = useTranslation();

    useEffect(() => {
        let content = document.getElementById("qna06");

        if (isOpened) {
            content.style.maxHeight = content.scrollHeight + "px";
        } else {
            content.style.maxHeight = null;
        }
    }, [isOpened]);

    return (
        <div className="accordion">
            <div className="accordion-title" onClick={() => onChangeOpenedFlag(5)}>
                <span className="hiclasstv-deepDarkgrey-text button">
                    <b>6. {t("FAQ_질문_6", { ns: "info" })}</b>
                </span>
            </div>
            <div className="accordion-content hiclasstv-darkgrey-text" id="qna06">
                <span className="d-flex" style={{ minWidth: 'max-content' }}>A.&nbsp;</span>
                <p>
                    {t("FAQ_공통_답변_감사", { ns: "info" })} {t("FAQ_질문_6_답변_1", { ns: "info" })}<br />
                    <b>{t("FAQ_질문_6_답변_2", { ns: "info" })}</b><br />
                    {t("FAQ_질문_6_답변_3", { ns: "info" })}<br />
                    <b>{t("FAQ_질문_6_답변_4", { ns: "info" })}</b><br />
                    {t("FAQ_질문_6_답변_5", { ns: "info" })}<br />
                    <b>{t("FAQ_질문_6_답변_6", { ns: "info" })}</b><br />
                    {t("FAQ_질문_6_답변_7", { ns: "info" })}<b>{t("FAQ_질문_6_답변_7_1", { ns: "info" })}</b>{t("FAQ_질문_6_답변_7_2", { ns: "info" })}<br />
                    <b>{t("FAQ_질문_6_답변_8", { ns: "info" })}</b><br />
                    {t("FAQ_질문_6_답변_9", { ns: "info" })}<br />
                    <b>{t("FAQ_질문_6_답변_10", { ns: "info" })}</b><br />
                    {t("FAQ_질문_6_답변_11", { ns: "info" })}
                </p>
            </div>
        </div>
    );
}

export default QnA006;